import { getLanguage } from '../state'
import { menuData } from './menuData'
import { MenuExternalLayers } from '../components/Menu/MenuExternalLayers'
import { Submenu } from '../components/Menu/Submenu'

/**
 * Only the dimensions that must be displayed to the user will be true
 * */
export const isUserDimension = ({ dimensionId }) => ![208].includes(dimensionId)

export const getUrlIndicatorMenu = () =>
  `https://api-cepalstat.cepal.org/cepalstat/api/v1/thematic-tree/?format=json&theme_id=27&lang=${getLanguage()}`

export const getUrlIndicator = ({ id, members }) =>
  `https://api-cepalstat.cepal.org/cepalstat/api/v1/indicator/${id}/data?members=${members}&lang=${getLanguage()}&format=json&app=geo-cepalstat`

export const getUrlDimensions = ({ id }) =>
  `https://api-cepalstat.cepal.org/cepalstat/api/v1/indicator/${id}/dimensions?lang=${getLanguage()}&format=json`

export const getUrlCountries = () => 'geodata/countries.geojson'
export const getUrlCitiesDepualc = () => 'geodata/cities_depualc.geojson'
export const getUrlDamDepualc = () => 'geodata/dam_depualc.geojson'

export const getUrlExternalLayers = () => 'api/externalLayers.json'

export const getHomePosition = () => ({
  center: [-84, 16],
  zoom: 5,
  pitch: 0
})

export const getUrlBaseLayers = () => 'api/baseLayers.json'

export const rangeColors = [
  ['red', '#ecdcb0', '#e6cc85', '#dfbc59', '#d9ab2d', '#d29b02', '#c38f01'],
  ['red', '#d7c0ba', '#d49f92', '#d17f6b', '#ce5f43', '#cb3f1b', '#c52700'],
  ['red', '#b8d9c9', '#8ebea7', '#64a284', '#3a8761', '#106b3f', '#015029'],
  ['red', '#edf4fa', '#c1d5e5', '#96b5cf', '#6a96b9', '#3f76a3', '#1f67a3'],
  ['red', '#d5f6f6', '#accdcd', '#82a3a3', '#587979', '#2f4f4f', '#213838']
]

export const rangeSize = [4, 5.3, 6.7, 8, 9.3, 10.7, 12]

export const LAYER_KIND = {
  EXTERNAL: 'EXTERNAL',
  INDICATOR: 'INDICATOR'
}

export const getMenu = () => menuData
export const getOdsData = () =>
  menuData
    .filter(({ id: idMenu }) => idMenu === 'filtroInformacion')[0]
    .submenu.filter(({ id: idSubmenu }) => idSubmenu === 'ODS')[0].submenu

export const getOptionsData = () =>
  menuData
    .filter(({ id: idMenu }) => idMenu === 'filtroInformacion')[0]
    .submenu.map(({ submenu }) => submenu)
    .flatMap((a) => a)
    .reduce((res, proj) => {
      if (proj.render === 'Option') {
        res.push(proj)
        if (proj.submenu.length > 0) {
          proj.submenu.forEach((sub) => res.push(sub))
        }
      }
      return res
    }, [])

export const sectionComponents = new Map([
  ['MenuIndicator', <Submenu key="MenuIndicator" indicator={true} />],
  ['MenuExternalLayers', <MenuExternalLayers key="MenuExternalLayers" />]
])
